import buildResourcePath from '@lib/buildResourcePath'
import Assets from '@lib/Assets'
import ValueFormatter from '../utils/ValueFormatter'

export default class IndexTableRowRenderer {
    constructor(props, indexTableRow) {
        this.props = props;
        this.indexTableRow = indexTableRow;

        this.prepareIndexTableRow();
    }

    setProps(props) {
        this.props = props;
    }

    prepareIndexTableRow() {
        this.indexTableRow.state = {
            ...this.indexTableRow.state
        }

        this.indexTableRow.openConfigRow = (value) => {
            this.indexTableRow.setState({configurationOpen: value});
        }
    }

    renderResponsibleColumn(column, value) {
        return (
            <td key={column.slug}>{value === null ? '-' : value}</td>
        );
    }

    renderNameColumn(column, value, children) {
        if (this.indexTableRow.props.allowNamesAsEditPageLinks && this.props.row.canEdit !== false) {
            let editButton = this.props.actionButtons.filter(x => x.slug === 'Edit')[0];
            let url = this.getUrl(editButton);

            return (
                <td className="index-name-column" key={column.slug}>
                    <span>
                        <a href={url} onClick={() => window.location.href = url}>{value}</a>
                        {children}
                    </span>
                </td>
            )
        }

        return this.renderMutedNameColumn(column, value, children);
    }

    renderMutedNameColumn(column, value, children) {
        return (
            <td className="index-name-column" key={column.slug}>
                <span>
                    {value}
                    {children}
                </span>
            </td>
        )
    }

    getRandomKey() {
        var random = "" + Math.random();
        return random.substring(2, 8);

    }

    getUrl = button => {
        if (button == null) {
            return;
        }
        let url;
        if (button.urlTemplate != '' && button.urlTemplate != undefined) {
            url = this.prepareUrl(button.urlTemplate);
        }

        return buildResourcePath(url);
    }

    prepareUrl = (urlTemplate) => {
        let url = urlTemplate;
        let params = urlTemplate.match(/\$\{([a-zA-Z0-9_]+)\}/g);
        for (let param of params) {
            let concreteParam = param.match(/[a-zA-Z0-9_]+/)[0];
            if (this.props.row[concreteParam] !== undefined) {
                url = url.replace(param, this.props.row[concreteParam]);
            }
        }

        if (url.substr(0, 1) == '/') {
            url = url.substr(1, url.length)
        }

        return url;
    }


    renderSpacer = () => {
        return (
            <tr className="index-table-spacer">
                <td></td>

                {this.props.columns.map((x, idx) => (
                    <td key={idx}></td>
                ))}

                <td></td>
            </tr>
        )
    }

}


